import type { ProductRewardSearchResult } from '@brandclub/common-ui';
import type { ReactNode } from 'react';

interface InpageAddToBagContentProps {
  renderAddToBagButton: (options: { hideRewards: boolean }) => ReactNode;
  renderLocationMap: () => ReactNode;
  renderRetailerInfo: (options: { hideMatchedRetailOffers: boolean }) => ReactNode;
}

export const getCatalogV2PriorityProduct = (
  currentProduct?: ProductRewardSearchResult,
): ProductRewardSearchResult | undefined => currentProduct;

export const CatalogV2InpageAddToBagContent = ({
  renderAddToBagButton,
  renderLocationMap,
}: InpageAddToBagContentProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      {renderAddToBagButton({ hideRewards: true })}
      {renderLocationMap()}
    </div>
  );
};
